export default {
    login: "Yaman-bot",
    id: 54019445,
    node_id: "MDQ6VXNlcjU0MDE5NDQ1",
    avatar_url: "https://avatars.githubusercontent.com/u/54019445?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Yaman-bot",
    html_url: "https://github.com/Yaman-bot",
    followers_url: "https://api.github.com/users/Yaman-bot/followers",
    following_url: "https://api.github.com/users/Yaman-bot/following{/other_user}",
    gists_url: "https://api.github.com/users/Yaman-bot/gists{/gist_id}",
    starred_url: "https://api.github.com/users/Yaman-bot/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Yaman-bot/subscriptions",
    organizations_url: "https://api.github.com/users/Yaman-bot/orgs",
    repos_url: "https://api.github.com/users/Yaman-bot/repos",
    events_url: "https://api.github.com/users/Yaman-bot/events{/privacy}",
    received_events_url: "https://api.github.com/users/Yaman-bot/received_events",
    type: "User",
    site_admin: false,
    name: "Yaman Aggarwal",
    company: null,
    blog: "",
    location: null,
    email: null,
    hireable: null,
    bio: null,
    twitter_username: null,
    public_repos: 12,
    public_gists: 0,
    followers: 4,
    following: 16,
    created_at: "2019-08-12T07:28:29Z",
    updated_at: "2021-04-06T17:30:07Z"
};
